export class DevRequestDraft {

  static validation(title: string, body: string): string | null {
    if (!title.trim() || title.trim().length > 300 || !body.trim() || body.trim().length > 200_000) {
      return '제목은 공백이 아닌 300자 이하, 요청 내용은 공백이 아닌 200,000자 이하여야 한다.';
    }
    return null;
  }

  static section(prd: string, name: string): string {
    const lines = prd.split('\n');
    let fence: string | null = null;
    let start = -1;
    let end = lines.length;
    for (let i = 0;i < lines.length;i += 1) {
      const mark = /^ {0,3}(`{3,}|~{3,})/.exec(lines[i]);
      if (mark) {
        if (fence === null) fence = mark[1][0]; else if (fence === mark[1][0]) fence = null;
        continue;
      }
      if (fence !== null) continue;
      if (start >= 0 && /^#{1,2}\s/.test(lines[i])) {
        end = i;
        break;
      }
      if (new RegExp(`^##[ \\t]+${name}[ \\t]*\\r?$`).test(lines[i])) start = i;
    }
    return start < 0 ? '' : lines.slice(start, end).join('\n').trim();
  }
  static fromPrd(epic: { title: string; slug: string }, prd: string): { title: string; body: string } {
    const background = this.section(prd, 'Background');
    const goals = this.section(prd, 'Goals');
    const paragraph = background.split('\n').slice(1).join('\n').trim().split(/\n\s*\n/)[0] ?? '';
    const sentence = paragraph.match(/^.*?[.!?。](?:\s|$)/)?.[0]?.trim() ?? paragraph;
    return {
      title: epic.title !== epic.slug ? epic.title : sentence || epic.slug,
      body: [background, goals].filter(Boolean).join('\n\n'),
    };
  }
}
